var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appointmentId)?_c('span',[_c('router-link',{attrs:{"to":{ name: '/meetingInit', params: {appointmentId:_vm.appointmentId} },"target":"_blank"}},[_c('font-awesome-icon',{staticStyle:{"font-size":"18px","display":"flex","justify-content":"center","margin-top":"3%"},attrs:{"icon":"fa-regular fa-video"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }